"use strict";

exports.__esModule = true;
exports.StyledToolbarButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledToolbarButton = _styledComponents.default.div`
    display: block;
    width: 40px;
    height: 40px;
    margin: 5px;

    button {
        width: 100%;
        height: 100%;
        padding: 7px;
        border: none;
        background-color: transparent;
        cursor: pointer;
        outline: none !important;

        svg {
            display: block;
            pointer-events: none;
            height: 100%;
            width: auto;
        }

        &:disabled {
            opacity: 0.5;
        }
    }

    .__react_component_tooltip {
        &.place-top {
            margin-top: 1px;
        }
        &.place-bottom {
            margin-top: -1px;
        }
    }
`;
exports.StyledToolbarButton = StyledToolbarButton;